

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, SectionHeader } from 'web-library';
import ExamRegistrationsListingTablesDialog from '../../modules/examRegistration/components/ExamRegistrationsListingTablesDialog';
import {typeTheme} from "web-library/theme/helper/tssHelper"

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  '@global': {
    '#exam-registration-listing': {
      '& .MuiTableRow-root': {
        verticalAlign: 'top',
        '&:not(:last-child)': {
          borderBottom: `1px solid ${theme.color.border.borderFocused} !important`,
        },
        '& .MuiTableCell-root': {
          '&[data-colindex="0"]': {
            minWidth: 200,
          },
        },
      },
      '& .MuiTableBody-root': {
        '& .MuiButtonBase-root': {
          height: '20px',
          padding: '12px',
        },
      },
    },
  },
  table: {
    marginBottom: theme.spacing(3),
  },
  alert: {
    marginBottom: theme.spacing(3),
  },
  amendOrViewButton: {
    color: theme.color.link.linkDefault01,
    padding: '0px !important',
    marginRight: theme.spacing(4),
    width: 'max-content',
  },
  tabsHeader: {
    '& .MuiTab-root': {
      textTransform: 'none',
    },
    marginBottom: theme.spacing(4),
    '& button': {
      maxWidth: '326px',
    },
  },
  examLevelCol: {
    '&:not(:last-child)': {
      marginBottom: theme.spacing(3),
    },
  },
  instruction: {
    marginBottom: theme.spacing(3),
  },
  iconContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  deleteButton: {
    color: theme.color.icon.iconTrash,
    whiteSpace: 'nowrap',
    padding: `${theme.spacing(1)} !important`,
    minHeight: 0,
    minWidth: 0,
    text: {
      padding: '0 !important',
    },
  },
  actionButtons: {
    display: 'flex',
    flexDirection: 'row',
    width: 'max-content',
    alignItems: 'center',
  },
  link: {
     ...typeTheme(theme, 'buttonSmall'),
  },
  accessArrangement: {
    marginTop: theme.spacing(3),
  },
  viewTransactionLink: {
    fontWeight: 800,
  },
}));

const ExamRegistrationsListingHomePage = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  return (
    <Box className={classes.table}>
      <SectionHeader title={t('admin->>HomePage.MyRegistrations')} />

      <ExamRegistrationsListingTablesDialog />
    </Box>
  );
};

export default ExamRegistrationsListingHomePage;
